import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';

export default {
  name: 'MainSettings',
  components: {
    Sidebar,
    Navbar
},
data: () => ({
    saving: false,
    savingNotif: false,
    accounts: [
      { key: "proba", name: "Proba Workflows", subtitle: "Plan properly your workflow", icon: require("@/assets/platforms_icons/proba-workflows.svg"),  enabled: true },
      { key: "orcaa", name: "Orcaa.ai", subtitle: "Integrate Projects Discussions",  icon: require("@/assets/platforms_icons/orcaa_ai.svg"), enabled: true },
      { key: "complyon", name: "ComplyOn", subtitle: "Integrate Projects Management", icon: require("@/assets/platforms_icons/complyon.svg"), enabled: false },
      { key: "xverdict", name: "X-Verdict", subtitle: "Case analytics & outcomes", icon: require("@/assets/platforms_icons/x-verdict.svg"), enabled: true },
      { key: "engagenet", name: "EngageNet", subtitle: "Community engagement", icon: require("@/assets/platforms_icons/engagenet.svg"), enabled: true },
      { key: "analytics", name: "Proba Analytics", subtitle: "Dashboards", icon: require("@/assets/platforms_icons/proba-analytics.svg"),  enabled: false },
    ],
    notifFrequency: "hourly",
    _snapshot: null,
    _notifSnapshot: null,
  }),
  mounted() {
    // take snapshots for "Discard"
    this._snapshot = JSON.stringify(this.accounts);
    this._notifSnapshot = this.notifFrequency;
  },
  methods: {
    discardChanges() {
      this.accounts = JSON.parse(this._snapshot);
    },
    async saveChanges() {
      this.saving = true;
      try {
        this._snapshot = JSON.stringify(this.accounts);
        this.$notyf?.success?.("Connections updated");
      } catch (e) {
        this.$notyf?.error?.("Failed to save connections");
      } finally {
        this.saving = false;
      }
    },
    resetNotifications() {
      this.notifFrequency = this._notifSnapshot;
    },
    async saveNotifications() {
      this.savingNotif = true;
      try {
        this._notifSnapshot = this.notifFrequency;
        this.$notyf?.success?.("Notification settings updated");
      } catch (e) {
        this.$notyf?.error?.("Failed to save notifications");
      } finally {
        this.savingNotif = false;
      }
    },
  },
};